import React, { useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addEmailList, addFileName } from "state/reducers/smsBatching";
import { Loading } from "components/common";
import { useDropzone } from "react-dropzone";
import { parseCsv, handleBlob, isObject } from "utils";
import "../../styles/marketing-dashboard.css";

const SMSUploadContainer = () => {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const emailList = useSelector((state) => state.smsBatching.emailList);
  const fileName = useSelector((state) => state.smsBatching.fileName);
  const dispatch = useDispatch();
  const handleRemove = () => {
    dispatch(addFileName(null));
    dispatch(addEmailList(null));
  };
  const onDrop = useCallback(async (acceptedFiles) => {
    if (!acceptedFiles.length) { return; }
    if (acceptedFiles) { dispatch(addFileName(acceptedFiles[0].path)); }
    try {
      setError("");
      setLoading(true);
      const droppedCsv = await handleBlob(acceptedFiles[0]);
      const parsedCsv = await parseCsv(droppedCsv);
      if (parsedCsv.length > 12000) {
        dispatch(addFileName(null));
        setError(
          `The maximum amount of queued messages is 12,000 in one batch. 
           Your current upload has exceeded that at ${parsedCsv.length} 
           queued messages`,
        );
        setLoading(false);
      } else {
        setLoading(false);
        dispatch(addEmailList(parsedCsv));
      }
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  }, []);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: ".csv",
  });
  return (
    <div className="flex flex-col p-10 m-auto rounded-lg ">
      {!emailList ? (
        <>
          <p className="text-center pb-2 mb-2 text-3xl">Upload CSV :</p>
          <small className="text-center mb-4">
              drag + drop or select files
          </small>
          {error && (
            <p className="text-center text-red-500 w-6/12 mx-auto">{error}</p>
          )}
          <div className="flex flex-row justify-center mt-3">
            {loading && <Loading />}
            {!emailList && (
              <div
                className="py-2 px-2 my-2 rounded-lg hover:bg-blue-500 duration-300 ease-in-out"
                style={{ border: "dotted 3px gray" }}
              >
                <div {...getRootProps()} className="text-center">
                  <input {...getInputProps()} className="bg-none" />
                  {isDragActive ? (
                    <i className="fas fa-file-upload text-3xl p-3 " />
                  ) : (
                    <i className="fas fa-file-upload text-3xl p-3 " />
                  )}
                </div>
              </div>
            )}
          </div>
        </>
      ) : (
        <div className="flex flex-col justify-center mx-auto my-auto">
          <div
            className="py-2 px-2 mb-5 rounded-lg hover:bg-blue-500 duration-300 ease-in-out"
            style={{ border: "dotted 3px gray" }}
          >
            <div className="text-center px-2">
              {fileName || "No file uploaded"}
              <i
                aria-hidden="true"
                onClick={handleRemove}
                className="fas fa-trash-alt text-red-500 ml-3 hover:text-white duration-300 ease-in-out"
              />
            </div>
          </div>
          <div className="text-center mx-auto mt-5">
            <i className="fas fa-user mr-2" />
            {emailList && emailList.length ? emailList.length : "0"}
          </div>
          <div className="text-center mx-auto mt-4">
            <small className="mr-2">
              <i className="fas fa-brackets-curly" />
            </small>
            {emailList &&
                emailList.length &&
                isObject(emailList[0]) &&
                Object.keys(emailList[0]).map((val, i) => {
                  return (
                    <React.Fragment key={val}>
                      <span className="text-gray-600">{val.toLowerCase()}</span>
                      {Object.keys(emailList[0]).length === i + 1 ? null : ", "}
                    </React.Fragment>
                  );
                })}
          </div>
        </div>
      )}
    </div>
  );
};

export default SMSUploadContainer;
